export const state = getInitialState();

export function getInitialState() {
  return {
    estimator: {
      key: null,
      loading: false,
      loaded: false,
      data: {}
    },
    publicEstimator: {
      year: null,
      type: null,
      loading: false,
      loaded: false,
      processing: false,
      edit: getBlankParameters(),
      unavailable: null,
      data: {}
    },
    playground: {
      key: null,
      loading: false,
      loaded: false,
      active: false,
      edit: getBlankParameters(),
      parameters: getBlankParameters(),
      data: {}
    }
  };
}

export function getUnloadedState() {
  return {
    estimator: { loaded: false },
    publicEstimator: { loaded: false },
    playground: { loaded: false }
  };
}

function getBlankParameters() {
  return {
    administrationFeeExempt: null,
    annualChargeLatePaymentDaysInPreviousYear: null,
    annualChargeLatePaymentDaysInPreviousYearMinus1: null,
    annualChargeLatePaymentDaysInPreviousYearMinus2: null,
    annualChargeLatePaymentDaysInPreviousYearMinus3: null,
    annualChargeLatePaymentDaysInPreviousYearMinus4: null,
    failedEftsl: null,
    financialStatementSupplied: null,
    isLiableForLastYearsAdministrativeFee: null,
    isNew: null,
    latePaymentMeasure: null,
    loanAmountsPaid: null,
    ltpsLevyLatePaymentDaysInPreviousYear: null,
    ltpsLevyLatePaymentDaysInPreviousYearMinus1: null,
    ltpsLevyLatePaymentDaysInPreviousYearMinus2: null,
    ltpsLevyLatePaymentDaysInPreviousYearMinus3: null,
    ltpsLevyLatePaymentDaysInPreviousYearMinus4: null,
    missingEftsl: null,
    netProfitBeforeTax: null,
    ongoingEftsl: null,
    passedEftsl: null,
    riskRatingExempt: null,
    sanctioned: null,
    shortRegistrationPeriod: null,
    specialTuitionProtectionExempt: null,
    studentCount: null,
    totalAssets: null,
    totalEquity: null,
    totalLiabilities: null,
    totalRevenue: null,
    withdrawnEftsl: null
  };
}
